import { BasePage } from '@/components/ui/base-page'
import { Outlet } from 'react-router-dom'

export function InvestmentServicesPage() {
  return (
    <BasePage
      title="Investment Services"
      description="Financial services and solutions"
    >
      <Outlet />
    </BasePage>
  )
}